import { compose } from 'recompose';
import { connect } from 'react-redux';

import {
  fetchMetricsData,
} from '../../../../../actions/metrics';
import {
  CHART_QUOTA_MONTHLY,
  HISTORICAL_METRIC_30DAYS,
  HISTORICAL_METRIC_52WEEKS,
} from '../../../../../constants/charts';
import {
  getApisWithRLQList,
  getChartData,
  getChartParams,
  getOrgMap,
  getIsChartLoading,
  getIsMetricTypeDataLoading,
} from '../../../../../reducers/metrics';

import MonthlyQuotaChart from '../../../../../components/Analytics/CannedCharts/UsageCharts/MonthlyQuotaChart';

const metric = 'usage';

export const mapDispatchToProps = (dispatch) => ({
  fetchCustomDateMetricsData: (params) =>
    dispatch(
      fetchMetricsData(
        CHART_QUOTA_MONTHLY,
        params,
        metric,
        params.aggregation,
        params.usageType,
      ),
    ),
});

export const mapStateToProps = (state) => ({
  defaultUsageResponse: getChartData(state, CHART_QUOTA_MONTHLY),
  apiMap: getApisWithRLQList(state),
  orgMap: getOrgMap(state),
  usageResponseFor30DaysAgo:
    getChartData(
      state,
      CHART_QUOTA_MONTHLY,
      HISTORICAL_METRIC_30DAYS,
    ),
  usageResponseFor52WeeksAgo:
    getChartData(
      state,
      CHART_QUOTA_MONTHLY,
      HISTORICAL_METRIC_52WEEKS,
    ),
  isLoading: getIsChartLoading(state, CHART_QUOTA_MONTHLY),
  is30DaysDataLoading: getIsMetricTypeDataLoading(
    state,
    CHART_QUOTA_MONTHLY,
    HISTORICAL_METRIC_30DAYS,
  ),
  is52WeeksDataLoading: getIsMetricTypeDataLoading(
    state,
    CHART_QUOTA_MONTHLY,
    HISTORICAL_METRIC_52WEEKS,
  ),
  usageParams: getChartParams(state, CHART_QUOTA_MONTHLY),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
)(MonthlyQuotaChart);
